import { ImageDesignTokens } from '@primeuix/themes/types/image';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/image/index.ts
const img = componentCommon.image;

export const ImageTelekomDT: ImageDesignTokens = {
  preview: {
    icon: { size: t(img.preview.icon.size) },
    mask: {
      background: t(img.preview.mask.background),
      color: t(img.preview.mask.color),
    },
  },
  toolbar: {
    background: t(img.toolbar.background),
    padding: t(img.toolbar.padding),
    gap: t(img.toolbar.gap),
    blur: t(img.toolbar.blur),
    borderColor: t(img.toolbar.border.color),
    borderWidth: t(img.toolbar.border.width),
    borderRadius: t(img.toolbar.border.radius),
    position: {
      right: t(img.toolbar.position.right),
      top: t(img.toolbar.position.top),
    },
  },
  action: {
    color: t(img.action.color),
    hoverBackground: t(img.action.hover.background),
    hoverColor: t(img.action.hover.color),
    size: t(img.action.size),
    iconSize: t(img.action.icon.size),
    borderRadius: t(img.action.border.radius),
    focusRing: {
      width: t(img.action.focus.ring.width),
      color: t(img.action.focus.ring.color),
      offset: t(img.action.focus.ring.offset),
    },
  },
};
